// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CasePayorRelationshipModel {
    static getAttributeTypeMap() {
        return CasePayorRelationshipModel.attributeTypeMap;
    }
}
CasePayorRelationshipModel.discriminator = undefined;
CasePayorRelationshipModel.additionalProperties = false;
CasePayorRelationshipModel.attributeTypeMap = [
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "CaseRoleType"
    },
    {
        "name": "caseRelations",
        "baseName": "caseRelations",
        "type": ""
    },
];
//# sourceMappingURL=casePayorRelationshipModel.js.map